import { HTMLAttributes, ReactElement } from 'react'
import {
  BackgroundProps,
  BorderProps,
  ColorProps,
  FlexboxProps,
  GridProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system'

import { GapProps, TestIdProps } from 'designSystem/types/propTypes'

import INTERNALxDiv from '../internal/elements/INTERNALxDiv'

export type BaseProps = HTMLAttributes<HTMLDivElement> &
  BackgroundProps &
  BorderProps &
  ColorProps &
  FlexboxProps &
  GapProps &
  GridProps &
  LayoutProps &
  PositionProps &
  ShadowProps &
  SpaceProps &
  TestIdProps &
  TypographyProps

type Props = BaseProps

export default function PDSPageContentArea({
  testId,
  ...props
}: Props): ReactElement {
  return (
    <INTERNALxDiv
      className="page-content-area"
      data-testid={testId}
      {...props}
    />
  )
}
